const pagesState = {
  data: {
    domainIds: [],
    page: 1,
    search: "",
    pages: [],
    totalLength: 0,
  },
};

export default pagesState;
